module.exports = __webpack_public_path__ + "res/roboto-v15-latin-700.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-700.woff
// module id = 103
// module chunks = 1